import { useEffect, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export default function PayPalCheckout({ listingId, onPaid }) {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { api.get("/market/config").then(({ data }) => setCfg(data)); }, []);

  if (!cfg) return null;
  if (!cfg.paypal_client_id)
    return <p className="rounded-xl border border-amber-300/20 bg-amber-300/5 p-4 text-sm text-amber-100/80" data-testid="paypal-not-configured">PayPal wird gerade eingerichtet – Kauf ist in Kürze möglich.</p>;

  return (
    <div data-testid="paypal-checkout" className="rounded-xl bg-white p-3">
      <PayPalScriptProvider options={{ clientId: cfg.paypal_client_id, currency: "EUR", intent: "capture", locale: "de_DE" }}>
        <PayPalButtons
          style={{ layout: "vertical", shape: "pill", color: "black" }}
          createOrder={async () => {
            try { const { data } = await api.post("/paypal/orders", { listing_id: listingId }); return data.id; }
            catch (e) { toast.error(errMsg(e)); throw e; }
          }}
          onApprove={async (d) => {
            try { await api.post(`/paypal/orders/${d.orderID}/capture`); toast.success("Zahlung erfolgreich – danke für deinen Kauf!"); onPaid?.(); }
            catch (e) { toast.error(errMsg(e)); }
          }}
          onError={() => toast.error("PayPal-Zahlung fehlgeschlagen")}
        />
      </PayPalScriptProvider>
    </div>
  );
}
